import { render } from "./activityGoods.vue?vue&type=template&id=66703b22&scoped=true"
import script from "./activityGoods.vue?vue&type=script&lang=js"
export * from "./activityGoods.vue?vue&type=script&lang=js"

import "./activityGoods.vue?vue&type=style&index=0&id=66703b22&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66703b22"]])

export default __exports__